import React from "react";
import { Link } from "react-router-dom";

const vehicles = [
  {
    name: "Volvo S90",
    slug: "volvo-s90",
    image: "vol3.webp",
    passengers: 3,
    bags: 3,
  },
  {
    name: "Cadillac XT6",
    slug: "cadillac-xt6",
    image: "xt61.webp",
    passengers: 3,
    bags: 3,
  },
  {
    name: "Mercedes S Class",
    slug: "mercedes-s-class",
    image: "sclass1.webp",
    passengers: 3,
    bags: 3,
  },
  {
    name: "BMW 7 Series",
    slug: "bmw-7-series",
    image: "bmw71.webp",
    passengers: 3,
    bags: 3,
  },
  {
    name: "Mercedes Maybach",
    slug: "mercedes-maybach",
    image: "may2.webp",
    passengers: 3,
    bags: 3,
  },
  {
    name: "Chevrolet Suburban",
    slug: "chevrolet-suburban",
    image: "subu1.webp",
    passengers: 6,
    bags: 6,
  },
  {
    name: "GMC Denali",
    slug: "gmc-denali",
    image: "gmc1.jpg",
    passengers: 6,
    bags: 6,
  },
  {
    name: "Lincoln Navigator",
    slug: "lincoln-navigator",
    image: "lin2.webp",
    passengers: 6,
    bags: 6,
  },
  {
    name: "Cadillac Escalade",
    slug: "cadillac-escalade",
    image: "esc2.JPG",
    passengers: 6,
    bags: 6,
  },
  {
    name: "Mercedes Sprinter 8 Seater",
    slug: "mercedes-sprinter-8-seater",
    image: "82.jpg",
    passengers: 8,
    bags: 8,
  },
  {
    name: "Mercedes Sprinter 11 Seater",
    slug: "mercedes-sprinter-11-seater",
    image: "111.webp",
    passengers: 11,
    bags: 11,
  },
  {
    name: "Mercedes Sprinter 15 Seater",
    slug: "mercedes-sprinter-15-seater",
    image: "152.png",
    passengers: 15,
    bags: 15,
  },
];

const LuxuryFleetSection = () => {
  return (
    <section className="w-full bg-white py-4 md:py-6 lg:py-8 xl:py-12">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6 lg:gap-8">
          {vehicles.map((car, index) => (
            <div
              key={index}
              className="relative overflow-hidden rounded-lg md:rounded-xl group shadow-lg"
            >
              {/* Image */}
              <img
                src={car.image}
                alt={car.name}
                className="w-full h-[250px] md:h-[300px] lg:h-[350px] xl:h-[420px] object-cover transition-transform duration-500 group-hover:scale-105"
              />

              {/* Gradient Overlay */}
              <div className="absolute inset-0 bg-gradient-to-t from-black/90 via-black/40 to-transparent"></div>

              {/* Content */}
              <div className="absolute bottom-3 md:bottom-4 lg:bottom-6 left-3 md:left-4 lg:left-6 right-3 md:right-4 lg:right-6 text-center text-white">
                <p className="text-xs md:text-sm tracking-wide mb-1 md:mb-2">
                  Passengers: {car.passengers} | Bags: {car.bags}
                </p>

                <h3 className="text-base md:text-lg lg:text-xl font-semibold text-white mb-3 md:mb-4 lg:mb-5">
                  {car.name}
                </h3>

                <div className="flex flex-col md:flex-row justify-center gap-2 md:gap-3 lg:gap-4">
                  <Link
                    to="/booknow"
                    className="px-3 md:px-4 lg:px-6 py-1.5 md:py-2 rounded-full border border-white text-white text-xs md:text-sm font-medium hover:bg-white hover:text-black transition cursor-pointer inline-block text-center"
                  >
                    BOOK NOW
                  </Link>
                  <Link
                    to={`/fleet/${car.slug}`}
                    className="px-3 md:px-4 lg:px-6 py-1.5 md:py-2 rounded-full border border-white text-white text-xs md:text-sm font-medium hover:bg-white hover:text-black transition cursor-pointer inline-block text-center"
                  >
                    READ MORE
                  </Link>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default LuxuryFleetSection;
